import { useRecoilValue } from 'recoil'
import { roleAtom } from '@/atoms/globalAtoms'
import { userAtom } from '@/atoms/_globalAtoms'
import { EDITOR_USER_ROLE, userTypes } from '@messenger/consts'
import { useIsAdmin } from './useIsAdmin'

/**
 * Whether the editor offers the "Is global verse" switch: to the admins
 * `useIsAdmin` names, except a corporation admin on its own account, whom
 * the server refuses a global verse. Internal staff, a user acting as admin
 * and a designer or QC edit session (the messenger-user role) keep it, as the
 * server admits them.
 */
export const useMayMakeVerseGlobal = (): boolean => {
  const isAdmin = useIsAdmin()
  const userRole = useRecoilValue(roleAtom)
  const user = useRecoilValue(userAtom)
  const corporationAdminOnly =
    user?.type === userTypes.corporationAdmin &&
    !user?.actAsAdmin &&
    userRole !== EDITOR_USER_ROLE.MESSENGER
  return isAdmin && !corporationAdminOnly
}
